import { render, staticRenderFns } from "./serget.vue?vue&type=template&id=ef8e9f5c&"
import script from "./serget.vue?vue&type=script&lang=js&"
export * from "./serget.vue?vue&type=script&lang=js&"
import style0 from "./serget.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports